import { ICallbackFormParams, IAccountingUser } from '@/interfaces';
import { FormCreateAccountingUser, ViewAccountingUserDetails } from '@/components/forms';
import { broadcastService } from '@/services';
import { TCallbackForm } from '@/types';

import { TFormData } from '@/components/forms/formCreateAccountingUser';

export type TCreateParams = {
    callback?: (data: ICallbackFormParams<IAccountingUser>) => void;
    onSubmit?: (data: TFormData) => Promise<void>;
};

export type TEditParams = {
    accountingUser: IAccountingUser;
    callback?: TCallbackForm<IAccountingUser>;
    onSubmit?: (data: TFormData) => Promise<void>;
};

const useFormAccountingUser = () => {

    const seeDetails = (accountingUser: IAccountingUser) =>
        accountingUser &&
        broadcastService
            .modal
            .show({
                content: (
                    <ViewAccountingUserDetails user={accountingUser} />
                ),
                width: 'lg'
            });

    const create = (params?: TCreateParams) =>
        broadcastService
            .modal
            .show({
                content: <FormCreateAccountingUser {...params} />,
                width: 'lg'
            });

    const edit = (params: TEditParams) =>
        broadcastService
            .modal
            .show({
                content: <FormCreateAccountingUser {...params} />,
                width: 'lg'
            });

    return ({
        seeDetails,
        create,
        edit
    });

};

export default useFormAccountingUser;
